import { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

export default function ScoreGauge({ score, size = 220, label = true }) {
  const spring = useSpring(0, { stiffness: 45, damping: 18 });
  useEffect(() => {
    spring.set(score);
  }, [score, spring]);

  const display = useTransform(spring, (v) => `${Math.round(v)}`);
  const r = 84;
  const c = 2 * Math.PI * r;
  const dash = useTransform(spring, (v) => c - (c * Math.min(100, Math.max(0, v))) / 100);
  const stroke = size / 11;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="legacy-score-dial" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 200 200" className="-rotate-90">
        <circle cx="100" cy="100" r={r} fill="none" stroke="#E5DEC9" strokeWidth={stroke} />
        <motion.circle
          cx="100"
          cy="100"
          r={r}
          fill="none"
          stroke="#C59B27"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          style={{ strokeDashoffset: dash }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-serif font-bold text-white leading-none text-[48px] sm:text-[64px]" style={{ textShadow: "0 2px 12px rgba(0,0,0,0.35)" }}>
          <motion.span>{display}</motion.span>
          <span className="text-[0.45em] align-top">%</span>
        </span>
        {label && <span className="mt-2 text-sm font-semibold text-cream/90 tracking-wide">Legacy Readiness</span>}
      </div>
    </div>
  );
}
